import { passwordType } from '@/utils';
import { z } from 'zod';

const oneTimeCodeType = z.string().min(1);

export const OneTimeCodeKeyModel = z.object({
  key: z.string().uuid(),
});

export const RequestOneTimeCodeFormSchema = z.object({
  email: z.string().email(),
});

export const ResetPasswordFormSchema = z.object({
  oneTimeCode: oneTimeCodeType,
  newPassword: passwordType,
});

export const RequestResetPasswordSchema = OneTimeCodeKeyModel.extend({
  otp: oneTimeCodeType,
  newPassword: passwordType,
});
